import { Input, InputNumber, InputNumberProps, InputProps } from 'antd';
import classNames from 'classnames';
import React from 'react';
import { NUMBER_MAX_VALUE } from '@/presentation/components/tds-form/config';
import styles from './index.module.scss';

export type TdsInputProps = InputProps;

export type TdsInputNumberProps = InputNumberProps;

export const TdsInput = (props: TdsInputProps) => (
    <Input
      {...props}
      className={classNames(styles.tdsInput, props.className)}
    />
);

export const TdsInputNumber = (props: InputNumberProps) => (
  <InputNumber
    max={NUMBER_MAX_VALUE}
    {...props}
    className={classNames(styles.tdsInputNumber, props.className)}
  />
);
